(function () {
    'use strict';
    
    angular.module('plagiat2017App')
        .factory('AssignmentsRequest', function () {
    
            function AssignmentsRequest() {
                this.pageNumber = 0;
                this.pageSize = 5;
                this.sortTab = [];
                this.simpleSearch = '';
                this.search = {};
            }
    
            return AssignmentsRequest;
        });
})();
